module.exports = __webpack_public_path__ + "img/steam-ja.d0c18d7e.png";